import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { EntryPoint, FieldType, LegType, SlideType, TabTypeProp } from '../../../models';
import Field from './Field';
import { Config, LocationUtils } from '../../../utils';
import { LocationFragment } from '../MobileFragments';
import { LocationAutocompleteSource } from '../../LocationAutocomplete/LocationAutocompleteSource';
import { PreviousSearchesSourceMobile } from '../../PreviousSearches/PreviousSearchesSourceMobile';
import { GeoLocationSource } from '../../GeoLocationSelector/GeoLocationSource';
import { ConnectedSegmentDeparture } from '../Segment/SegmentDeparture';
import { ErrorUtils } from '../../../utils/ErrorUtils';
import { useSegmentContext } from '../Segment/SegmentManager/Context';

export const DepartureField = ({ geoLocationEnabled, activeProduct }) => {
    const { t } = useTranslation();
    const { segment } = useSegmentContext();
    const { id } = segment;
    const direction = Config.get('isRtl') ? 'rtl' : 'ltr';
    const maxPreviousSearches = 4;
    const placeholder = t('citySearch.departure');
    const getErrorMessage = (error) => t(ErrorUtils.getLocationErrorKey(error, EntryPoint.FLIGHTS));
    const getSources = () => {
        const previousSearches = PreviousSearchesSourceMobile({
            maxPreviousSearches,
            field: FieldType.DEPARTURE,
            id,
            activeProduct,
        });
        const locationAutocomplete = LocationAutocompleteSource({
            departureOrArrival: LegType.DEPARTURE,
            activeProduct,
        });

        const sources = [locationAutocomplete];

        if (geoLocationEnabled) {
            const geoLocation = GeoLocationSource();
            sources.push(geoLocation);
        }

        sources.push(previousSearches);
        return sources;
    };

    return (
        <ConnectedSegmentDeparture segmentId={id}>
            {({ error, setValue, value, isDisabled }) => (
                <>
                    <Field
                        errorMessage={getErrorMessage(error)}
                        icon="plane-going"
                        id={FieldType.DEPARTURE}
                        placeholder={placeholder}
                        value={LocationUtils.getFieldText(value, direction)}
                        isDisabled={isDisabled}
                    />
                    <LocationFragment
                        id={SlideType.DEPARTURE}
                        setValue={setValue}
                        sources={getSources()}
                        value={value}
                    />
                </>
            )}
        </ConnectedSegmentDeparture>
    );
};

DepartureField.propTypes = {
    activeProduct: TabTypeProp,
    geoLocationEnabled: PropTypes.bool.isRequired,
};
